
    export default {
        name: 'App'
    };
